import axios from 'axios';

export const API_BASE_URL =
 (import.meta as any).env?.VITE_API_URL || 'http://localhost:8787';

const api = axios.create({
 baseURL: `${API_BASE_URL}/api`,
 timeout: 30000,
 headers: {
  'Content-Type': 'application/json',
 },
});

// Request interceptor to add auth token
api.interceptors.request.use((config) => {
 const token = localStorage.getItem('auth_token');
 if (token) {
  config.headers.Authorization = `Bearer ${token}`;
 }
 return config;
});

// Response interceptor for token expiration (401)
api.interceptors.response.use(
 (response) => response,
 async (error) => {
  const originalRequest = error.config;

  // Handle 401 Unauthorized
  if (
   error.response?.status === 401 &&
   originalRequest &&
   !originalRequest._retry
  ) {
   originalRequest._retry = true;

   // Try refresh token if available
   const refreshToken = localStorage.getItem('refresh_token');
   if (refreshToken) {
    try {
     const response = await axios.post(`${API_BASE_URL}/api/auth/refresh`, {
      refreshToken,
     });
     const { token: newToken, refreshToken: newRefreshToken } =
      response.data.data;

     localStorage.setItem('auth_token', newToken);
     localStorage.setItem('refresh_token', newRefreshToken);

     originalRequest.headers.Authorization = `Bearer ${newToken}`;
     return api(originalRequest);
    } catch (refreshError) {
     // Refresh failed, clear and logout
     handleLogout();
    }
   } else {
    handleLogout();
   }
  }

  return Promise.reject(error);
 }
);

function handleLogout() {
 localStorage.removeItem('auth_token');
 localStorage.removeItem('refresh_token');
 localStorage.removeItem('user_data');

 // Trigger AuthProvider to clear state and redirect via ProtectedRoute
 window.dispatchEvent(new CustomEvent('auth:expired'));
}

export default api;
